import React from "react";
import { SearchedCompany } from ".";

export const CompanyResult = (props: SearchedCompany) => (
  <div className="flex p-2 items-center gap-4 bg-white rounded-full hover:bg-background-lightest transition">
    <div className="min-w-[32px] min-h-[32px] w-8 h-8 flex items-center justify-center bg-white rounded-full">
      <img
        className="max-w-full max-h-full rounded-full"
        src={props.logo_url || "https://storage.googleapis.com/getpro-public/e1ca4dfa-7173-40a1-8f9a-917dc3f3556f"}
      />
    </div>
    <div>{props.name}</div>
  </div>
);
